/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { ErrorService } from '../../services/error.service';
import { EventService } from '../../services/event.service';
import { AccountService } from '../../services/account.service';
import { WorkflowService } from '../../services/workflow.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { DriftService } from '../../services/drift.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

import { Constants, EmailType, ContactQuality, StaticDate } from '../../global/constants';

//import { Animations } from '../../global/animations';

@Component({
  selector: 'app-workflows',
  templateUrl: './workflows.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class WorkflowsComponent implements OnInit {
  loadingPage:boolean = true;
  session: any;
  currentType: EmailType;
  showAll: boolean = false;
  toggleNoIntegrations: boolean = false;

  selectDialogRef: BsModalRef;

  integrations: any = {
    marketo: false,
    eloqua: false,
    hubspot: false,
    acton: false,
    pardot: false
  };

  integrationCount: number = 0;
  singleIntegration: string = '';

  workflows: Array<any> = [];
  activeWorkflows: Array<any> = [];

  wfCount: any = {
    new: 0,
    existing: 0,
    alert: 0
  };

  constructor(private sessionService: SessionService,
              private cacheService: CacheService,
              private errorService: ErrorService,
              private eventService: EventService,
              private accountService: AccountService,
              private workflowService: WorkflowService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService,
              private constants: Constants) {}

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  select(dialog) {
    this.selectDialogRef = this.modalService.show(dialog, {class: 'modal-lg'});
  }

  filterType(t: EmailType) {
    this.currentType = t;
    this.session.workflow_filters.type = t.typeName;
    this.loadWorkflows();
    this.saveSession();
  }

  filterWFType(wfType: string) {
    this.session.workflow_filters.wf_type = wfType;
    this.setActiveWorkflows();
    this.saveSession();
  }

  toggle(wf) {
    var msg = 'turned on';
    wf.enabled = !wf.enabled;
    if (!wf.enabled) {
      msg = 'turned off';
      this.driftService.track('disabled-workflow', { type: this.workflowType(wf), id: wf._id });
    }
    else {
      this.driftService.track('enabled-workflow', { type: this.workflowType(wf), id: wf._id });
    }
    this.workflowService.setEnabled(wf._id, wf.enabled).subscribe(
      (result: any) => {
        this.globalMessageService.message('Workflow was ' + msg);
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'workflows.component', 'toggle');
      }
    )
  }

  delete(wf) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to delete this workflow',
        confirm: function() {
          me.workflowService.setDeleted(wf._id).subscribe(
            (result: any) => {
              me.workflows.splice(me.workflows.indexOf(wf), 1);
              me.setActiveWorkflows();
              me.globalMessageService.message('Workflow was deleted');
              me.driftService.track('deleted-workflow', { type: me.workflowType(wf), id: wf._id });            },
            error => {
              me.globalMessageService.error();
              me.errorService.log(error, 'workflows.component', 'delete');
            }
          )
        }
      }
    }));
  }

  clone(wf) {
    var newWF = JSON.parse(JSON.stringify(wf));
    newWF._id = "new";
    delete newWF.created_at;
    this.workflowService.saveNew(newWF).subscribe(
      (result: any) => {
        this.globalMessageService.message('Workflow was cloned');
        this.driftService.track('cloned-workflow', { type: this.workflowType(wf), id: wf._id });
        this.loadWorkflows();
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'workflows.component', 'clone');
      }
    )
  }

  toggleDetail(show: boolean) {
    this.showAll = show;
    this.eventService.toggleAllWorkflowDetails$.emit(show);
  }

  private initView() {
    // make sure workflow filters exist for this user
    if (!this.session.workflow_filters) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.workflow_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    this.currentType = this.constants.emailTypes.find((i) => {
      return i.typeName == this.session.workflow_filters.type;
    });

    this.loadIntegrations();
    this.loadWorkflows();
  }

  private loadIntegrations() {
    this.integrationCount = 0;
    this.accountService.getIntegrations().subscribe(
      (result: any) => {
      if (result.marketo) {
        this.integrations.marketo = true;
        this.integrationCount++;
        this.singleIntegration = 'marketo';
      }
      if (result.eloqua) {
        this.integrations.eloqua = true;
        this.integrationCount++;
        this.singleIntegration = 'eloqua';
      }
      if (result.hubspot) {
        this.integrations.hubspot = true;
        this.integrationCount++;
        this.singleIntegration = 'hubspot';
      }
      if (result.acton) {
        this.integrations.acton = true;
        this.integrationCount++;
        this.singleIntegration = 'acton';
      }
      if (result.pardot) {
        this.integrations.pardot = true;
        this.integrationCount++;
        this.singleIntegration = 'pardot';
      }
    },
    error => {
      this.globalMessageService.error();
      this.errorService.log(error, 'workflows.component', 'initView');
    });
  }

  private loadWorkflows() {
    this.loadingPage = true;
    this.wfCount = {
      new: 0,
      existing: 0,
      alert: 0
    };

    this.workflowService.getWorkflows().subscribe(
      (result: any) => {
        this.workflows = result;
        this.setActiveWorkflows();
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'workflows.component', 'loadWorkflows');
      }
    )
  }

  private setActiveWorkflows() {
    this.activeWorkflows = [];
    this.wfCount.new = 0;
    this.wfCount.existing = 0;
    this.wfCount.alert = 0;
    this.workflows.forEach((wf) => {
      if (this.currentType.typeName == 'all' || wf.trigger.type.indexOf(this.currentType.typeName) >= 0 ) {
        if (wf.trigger.data == 'contacts') {
          this.wfCount.new++;
          if (wf.partner=='acton' && !wf.action.list.id) {
            wf.invalid = true;
          }
          if (wf.trigger.type.length == 0) {
            wf.invalid = true;
          }
          if (this.session.workflow_filters.wf_type=='contacts') {
            this.activeWorkflows.push(wf);
          }
        }
        else if (wf.trigger.data == 'recipient') {
          this.wfCount.existing++;
          if (!wf.action.list.id && wf.action.fields.length==0 && wf.action.static_fields.length==0) {
            wf.invalid = true;
          }
          if (wf.trigger.type.length == 0) {
            wf.invalid = true;
          }
          if (this.session.workflow_filters.wf_type=='recipient') {
            this.activeWorkflows.push(wf);
          }
        }
        else {
          this.wfCount.alert++;
          if (wf.action.domain.length==0 && wf.action.forwards.length==0) {
            wf.invalid = true;
          }
          if (wf.trigger.type.length == 0) {
            wf.invalid = true;
          }
          if (this.session.workflow_filters.wf_type=='alert') {
            this.activeWorkflows.push(wf);
          }
        }
      }
    });

    this.invalidateWorkflows();
  }

  /**
   * It's possible for them to invalidate a workflow that's enabled - let's make sure to disable any if that happens
   */
  private invalidateWorkflows() {
    this.activeWorkflows.forEach((wf) => {
      if (wf.invalid && wf.enabled) {
        wf.enabled = false;
        this.workflowService.setEnabled(wf._id, false).subscribe(
          (result: any) => {
            // Nothing
          },
          error => {
            // Supress
          }
        )
      }
    });
  }

  private resetFilters() {
    this.session.workflow_filters = {
      type: 'all',
      wf_type: 'contacts',
      sort: {
        field: 'ls_date',
        direction: -1
      }
    };

    this.saveSession();
  }

  private saveSession() {
    this.session.workflow_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'workflows.component', 'saveSession');
      }
    )
  }

  private workflowType(wf) {
    let type = 'Create contacts';
    if (wf.partner == 'siftrock') {
      type = 'Route email';
    }
    else if (wf.trigger.data != 'contacts') {
      type = 'Update contacts';
    }
    return type;
  }
}



// WEBPACK FOOTER //
// ./client/app/config/workflows/workflows.component.ts